<!-- <div class="marquee-wrapper m-0">

    <div class="marquee-block">
        <div class="marquee-inner to-left">

            <span>
                <div class="marquee-item">
                    <img src="assets/images/new/cybersecurity_company_of_the_year.webp"
                        alt="CYBERSECURITY COMPANY OF THE YEAR 2023">
                </div>
                <div class="marquee-item">
                    <img src="assets/images/new/innovation_security.png" alt="INNOVATION SECURITY 2023">
                </div>
                <div class="marquee-item">
                    <img src="assets/images/new/award_4.webp" alt="DSCI INNOVATION">
                </div>
                <div class="marquee-item">
                    <img src="assets/images/new/award_2.webp" alt="AMAZON SAMBHAV SUMMIT 2021">
                </div>
                <div class="marquee-item">
                    <img src="assets/images/new/award_1.webp" alt="CXO TECH SUMMIT AND AWARDS 2022">
                </div>
                <div class="marquee-item">
                    <img src="assets/images/new/award_3.webp" alt="CIO INSIDER">
                </div>
                <div class="marquee-item">
                    <img src="assets/images/new/award_5.webp" alt="DSCI Innovation">
                </div>
                <div class="marquee-item">
                    <img src="assets/images/new/award_6.webp" alt="AMAZON SAMBHAV SUMMIT 2021">
                </div>

            </span>
            <span>
                <div class="marquee-item">
                    <img src="assets/images/new/cybersecurity_company_of_the_year.webp"
                        alt="CYBERSECURITY COMPANY OF THE YEAR 2023">
                </div>
                <div class="marquee-item">
                    <img src="assets/images/new/innovation_security.png" alt="INNOVATION SECURITY 2023">
                </div>
                <div class="marquee-item">
                    <img src="assets/images/new/award_4.webp" alt="DSCI INNOVATION">
                </div>
                <div class="marquee-item">
                    <img src="assets/images/new/award_2.webp" alt="AMAZON SAMBHAV SUMMIT 2021">
                </div>
                <div class="marquee-item">
                    <img src="assets/images/new/award_1.webp" alt="CXO TECH SUMMIT AND AWARDS 2022">
                </div>
                <div class="marquee-item">
                    <img src="assets/images/new/award_3.webp" alt="CIO INSIDER">
                </div>
                <div class="marquee-item">
                    <img src="assets/images/new/award_5.webp" alt="DSCI Innovation">
                </div>
                <div class="marquee-item">
                    <img src="assets/images/new/award_6.webp" alt="AMAZON SAMBHAV SUMMIT 2021">
                </div>

            </span>

        </div>
    </div>

</div> -->

<ngx-slick-carousel class="cust-about-us" #slickModal="slick-carousel" [config]="slideConfig" (init)="slickInit()"
  (breakpoint)="breakpoint()" (afterChange)="afterChange()" (beforeChange)="beforeChange()">
  <div ngxSlickItem  *ngFor="let slide of slides" class="slide p-3">
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div class="col-md-12 text-center">
          <img [src]="slide.img" alt="Random first slide" width="90%" height="auto" class="img-fluid mx-auto d-block">
        </div>
      </div>
    </div>
  </div>
</ngx-slick-carousel>